import { configureStore } from "@reduxjs/toolkit"
import commonSlice from "./commonSlice"
import themeSetting from "./themeSettingSlice"
import authReducer from "./authSlice"
import formBuilderReducer from "./formBuilderSlice"
import submissionsReducer from "./submissionSlice"
import attendanceReducer from "./attendanceSlice"
import vanPhotoReducer from "./vanPhotoSlice"
import permissionsReducer from "./permissionsSlice"
import auditSlice from "./auditSlice"
import auditTypeSlice from "./auditTypeSlice"
import rolesReducer from "./rolesSlice"
import sanitizedReportsReducer from "./sanitizedReportsSlice"
import auditReportReducer from "./auditReportSlice"
import auditReportSubmissionReducer from "./auditReportSubmissionSlice"
import orderVehicleAssignmentReducer from "./orderVehicleAssignmentSlice"

export const store = configureStore({
  reducer: {
    commonSlice,
    themeSetting,
    auth: authReducer,
    formBuilder: formBuilderReducer,
    submissions: submissionsReducer,
    attendance: attendanceReducer,
    vanPhoto: vanPhotoReducer,
    permissions: permissionsReducer,
    auditSlice,
    auditTypeSlice,
    roles: rolesReducer,
    sanitizedReports: sanitizedReportsReducer,
    auditReportSlice: auditReportReducer,
    auditReportSubmissionSlice: auditReportSubmissionReducer,
    orderVehicleAssignment: orderVehicleAssignmentReducer,
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch 
